import { useState, useEffect, useCallback } from 'react';
import { checkAIAvailable } from '../services/aiService';

interface UseAIReturn {
  aiAvailable: boolean;
  aiModel: string;
  aiChecking: boolean;
  checkAI: () => Promise<void>;
}

export const useAI = (): UseAIReturn => {
  const [aiAvailable, setAIAvailable] = useState<boolean>(false);
  const [aiModel, setAIModel] = useState<string>('');
  const [aiChecking, setAIChecking] = useState<boolean>(true);

  const checkAI = useCallback(async () => {
    setAIChecking(true);
    const { available, model } = await checkAIAvailable();
    setAIAvailable(available);
    setAIModel(model);
    setAIChecking(false);
  }, []);

  // Check AI availability on mount
  useEffect(() => {
    checkAI();
  }, [checkAI]);

  return {
    aiAvailable,
    aiModel,
    aiChecking,
    checkAI,
  };
};
